/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const FACET_QUERY_RE = /(?:^|[?&])facet=([\s\S]*?)(?=&(?:sort(?:by)?|[a-z][\w-]*)=|$)/i;
const PRICE_RANGE_RE = /^(\d+(?:\.\d+)?)-(\d+(?:\.\d+)?)$/;
const OPEN_ENDED_PRICE_RE = /^(\d+(?:\.\d+)?)-\*$/;

export const isFacetApplied = (query = '') => {
    const facetMatch = query.match(FACET_QUERY_RE);
    return Boolean(facetMatch?.[1]?.trim());
};

export const updateFacetQuery = (query = '', facetValues = []) => {
    const facetMatch = query.match(FACET_QUERY_RE);
    if (!facetMatch || typeof facetMatch.index !== 'number') return query;

    const matchedSegment = facetMatch[0];
    const prefix = query.slice(0, facetMatch.index);
    const suffix = query.slice(facetMatch.index + matchedSegment.length);
    const separator = matchedSegment.startsWith('?') ? '?' : '&';
    const facetSegment = facetValues.length ? `${separator}facet=${facetValues.join('&')}` : '';
    let nextQuery = `${prefix}${facetSegment}${suffix}`;

    if (!facetSegment && query.startsWith('?') && nextQuery.startsWith('&')) {
        nextQuery = `?${nextQuery.slice(1)}`;
    }

    return nextQuery;
};

const BRAND_NAME_BY_ID = {
    1001: '1-800-Flowers',
    1002: 'The Popcorn Factory',
    1009: '1-800-Baskets',
    1010: 'Fruit Bouquets',
    1012: "Cheryl's Cookies",
    1018: 'Stock Yards',
    1019: 'Harry & David',
    1020: "Wolferman's",
    1022: 'Personalization Universe',
    1025: 'Simply Chocolate',
    1026: 'The Market',
    1027: 'The Market',
    1029: "Shari's Berries",
    1030: 'Personalization Mall',
    1031: 'Vital Choice',
    1033: 'Things Remembered',
    1034: 'Florists',
};

/**
 * Builds fallback selected-facet objects from the URL when facet metadata is
 * unavailable. The `sortBy` parameter is intentionally excluded.
 */
export const getFallbackFacetsFromQuery = (query = '') => {
    const facetMatch = query.match(FACET_QUERY_RE);
    if (!facetMatch?.[1]) return [];

    return facetMatch[1]
        .split('&')
        .map((value) => value.trim())
        .filter(Boolean)
        .map((value) => {
            const priceRange = value.match(PRICE_RANGE_RE);
            const openEndedPrice = value.match(OPEN_ENDED_PRICE_RE);
            let label;

            if (priceRange) {
                label = priceRange[1] === '0' ? `Under $${priceRange[2]}` : `$${priceRange[1]} to $${priceRange[2]}`;
            } else if (openEndedPrice) {
                label = `Above $${openEndedPrice[1]}`;
            } else {
                const token = value.split('|').pop() || value;
                if (value.startsWith('brandId|')) {
                    label = BRAND_NAME_BY_ID[token] ?? token;
                } else {
                    label = token
                        .replace(/[_-]+/g, ' ')
                        .replace(/(^|\s)([a-z])/g, (_match, separator, character) => `${separator}${character.toUpperCase()}`);
                }
            }
            return { label, value };
        });
};
